import { Button, ButtonProps, ComponentWithAs, forwardRef, useToast } from '@chakra-ui/react';
import React from 'react';
import { Food } from '../../../type';
import { foods } from '../../../constants/food';
import { useRecoilState } from 'recoil';
import { excludeCategories, excludeFoods } from '../../../atoms/chooseState';
import { categories } from '../../../constants/category';
import { useHistory } from 'react-router-dom';
import { increaseCount } from '../../../hooks/firebaseHooks';
import { gaRecommend } from '../../../utils/gaUtils';

type RecommendButtonProps = {
  text: '추천받기' | '다시 추천받기' | '다시 추천 받을래요';
  exclude?: Food;
};

const recommendFood = (excludedCategoryIds: Set<string>, excludedFoodIds: Set<string>): Food => {
  const excludedCategories = Array.from(excludedCategoryIds).map((categoryId) => categories[categoryId]);
  const excludedFoods = Array.from(excludedFoodIds).map((foodId) => foods[foodId]);
  const filteredFoods = Object.values(foods).filter(
    (food) =>
      !food.category.some((category) => excludedCategories.includes(category)) &&
      !excludedFoods.includes(food),
  );
  return filteredFoods[Math.floor(Math.random() * filteredFoods.length)];
};

const RecommendButton: ComponentWithAs<'button', RecommendButtonProps & ButtonProps> = forwardRef<
  RecommendButtonProps & ButtonProps,
  'button'
>((props, ref) => {
  const history = useHistory();
  const toast = useToast();
  const [excludedCategories, setExcludedCategories] = useRecoilState(excludeCategories);
  const [excludedFoods, setExcludedFoods] = useRecoilState(excludeFoods);
  if (props.exclude) {
    setExcludedFoods(excludedFoods.add(props.exclude.name));
  }
  let isResetRequested = false;
  const click = () => {
    if (isResetRequested) return;
    const selected = recommendFood(excludedCategories, excludedFoods);
    if (selected !== undefined) {
      increaseCount().then();
      gaRecommend(selected.name, excludedCategories, excludedFoods);
      history.push('/result/' + selected.name);
    } else {
      setExcludedFoods(new Set<string>());
      setExcludedCategories(new Set<string>());
      isResetRequested = true;
      toast({
        title: '선택할 수 있는 음식 없음',
        description: '선택할 수 있는 음식이 없습니다. 필터를 초기화합니다.',
        position: 'top',
        status: 'error',
        duration: 2000,
        isClosable: false,
        onCloseComplete: () => {
          isResetRequested = false;
          const selected = recommendFood(new Set<string>(), new Set<string>());
          history.push('/result/' + selected.name);
        },
      });
    }
  };
  return (
    <Button ref={ref} {...(props as ButtonProps)} onClick={click}>
      {props.text}
    </Button>
  );
});

export default RecommendButton;
